/**
 * 预览海报模板
 * @author tanglinxia
 * @since 21/09/30
 */

import './poster-preview.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TplCover from 'components/store-tpl-box/tpl-cover';

const IFRAME_WIDTH = 320;
const IFRAME_HEIGHT = 504;

class PosterPreview extends Component {
  static propTypes = {
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  renderScrollTip() {
    return (
      <div className="s-preview-poster-tips">
        <span>鼠标悬停可预览全部</span>
        <i className="s-icon icon-huadong" />
      </div>
    );
  }

  render() {
    let { data } = this.props;
    let { type, width, height, cover } = data;

    const ratio = width && height ? width / height : null;
    const posterHeight = ratio
      ? Math.ceil(IFRAME_WIDTH / ratio)
      : IFRAME_HEIGHT;

    const isLongPage = posterHeight > IFRAME_HEIGHT;
    const coverStyle = {
      width: IFRAME_WIDTH,
      height: isLongPage ? IFRAME_HEIGHT : posterHeight,
    };

    const imgStyle = isLongPage
      ? {}
      : {
          overflow: 'hidden',
          height: '100%',
          objectFit: 'cover',
        };

    return (
      <div className="s-preview-iframe poster-preview">
        <TplCover
          style={coverStyle}
          cover={cover}
          category={type}
          containerWidth={IFRAME_WIDTH}
          imgStyle={imgStyle}
          isPosterPreview={isLongPage}
        />
        {posterHeight > IFRAME_HEIGHT ? this.renderScrollTip() : ''}
      </div>
    );
  }
}

export default PosterPreview;
